module.exports = __webpack_public_path__ + "static/media/medicine_vector.a558ce6e.svg";